import React from 'react'
import {
  ItemsContainer,
  Paragraph,
  StyledPhoneContainer,
} from '../components/SellerNotAvailable/SellerNotAvailable.styles'
import { Button } from '../components/Kit/Buttons/Button'
import styled from 'styled-components'
import { useSearchParams } from 'react-router-dom'
import { Splash } from '../components/Splash'
import { useStore } from '../hooks/useStore'
import StoreNotFound from './storeNotFound'
import { useEventById } from '../hooks/use-event-by-id'
import { BackgroundImageWithFallback } from '../components/BackgroundImageWithFallback'
import fallbackBackground from '../../assets/fallback_background.jpeg'
import { StoreLogoWithFallback } from '../components/StoreLogoWithFallback'
import { TopNavBar } from '../components/Call/TopNavBar'

const NavBarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
`

const LogoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const ButtonContainer = styled(ItemsContainer)`
  flex: 1;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: 0;
  gap: 2rem;
`

const themes = {
  sunset: {
    paragraph: '#FFFFFF',
    buttonBackground: '#F93700',
    buttonText: '#FFFFFF',
  },
  sunsetBlack: {
    paragraph: '#000000',
    buttonBackground: '#F93700',
    buttonText: '#FFFFFF',
  },
  noir: {
    paragraph: '#FFFFFF',
    buttonBackground: '#000000',
    buttonText: '#FFFFFF',
  },
  noirBlack: {
    paragraph: '#000000',
    buttonBackground: '#000000',
    buttonText: '#FFFFFF',
  },
}

export function FinishedEvent() {
  const { data: event, isLoading: isLoadingEvent, error: eventError } = useEventById()
  const currentTheme = themes[event?.theme ?? 'noir']
  const { data: store, isLoading: isLoadingStore, error: storeError } = useStore()
  const [searchParams] = useSearchParams()
  const isIframe = searchParams.get('iframe') === 'true'

  if (isLoadingEvent || isLoadingStore) {
    return <Splash />
  }

  if (eventError || storeError) {
    return <StoreNotFound />
  }

  return (
    <BackgroundImageWithFallback
      desktop={event.images?.['finished-desktop']}
      mobile={event.images?.['finished-mobile']}
      fallback={fallbackBackground}
    >
      <StyledPhoneContainer elevation={0} backgroundColor="transparent">
        {isIframe && (
          <NavBarContainer>
            <TopNavBar isIframe={isIframe} />
          </NavBarContainer>
        )}
        <LogoContainer>
          <StoreLogoWithFallback src={store.logoUrl} alt={'Store logo'} />
        </LogoContainer>
        <ButtonContainer>
          {event.redirect?.title && (
            <Paragraph color={currentTheme?.paragraph}>{event.redirect.title}</Paragraph>
          )}
          <Button
            variant="contained"
            color="primary"
            marginTop="0"
            href={event.redirect?.callToAction?.url ?? 'https://www.instagram.com/gojiraf/#'}
            target="_blank"
            backgroundColor={currentTheme?.buttonBackground}
            textColor={currentTheme?.buttonText}
          >
            {event.redirect?.callToAction?.label ?? 'Ingresar'}
          </Button>
        </ButtonContainer>
      </StyledPhoneContainer>
    </BackgroundImageWithFallback>
  )
}
